export default __webpack_public_path__ + "static/media/35A32A_2_0-ecfc321f0ba1ba64e4b0df90de153b1d.fbc017e9.woff2";